/**
 * FTL Living Interface — typography scale (single source of truth).
 *
 * Replaces ad-hoc `text-[13px]/[11px]/[12px]` scattered across surfaces (the
 * "27 people designed it" tell). One face (Inter), tight tracking on headings.
 * The `eyebrow` token carries the login/home DNA (brand-600, wide tracking).
 */
export const TYPE = {
  displayXl: "text-2xl font-bold tracking-tight",                 // 24 — page title
  display: "text-xl font-semibold tracking-tight",               // 20 — section
  heading: "text-lg font-semibold",                              // 18
  body: "text-sm",                                               // 14 — default body
  bodyMed: "text-sm font-medium",                                // nav + form labels
  meta: "text-xs text-[var(--color-text-tertiary)]",            // 12 — metadata
  eyebrow:
    "text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-600", // signature label
  badge: "text-[10px] font-semibold tabular-nums",
} as const;

export type TypeToken = keyof typeof TYPE;
